import { connect } from 'react-redux';

import UserDropdown from './UserDropdown';
import { setPersonalizationUserDropdownOpen } from '../HeaderComponentActions';
import { isPersonalizationUserDropdownOpen } from '../HeaderComponentSelectors';

function mapStateToProps(state) {
  return {
    isUserDropdownOpen: isPersonalizationUserDropdownOpen(state),
  };
}

const mapDispatchToProps = {
  setUserDropdownOpen: setPersonalizationUserDropdownOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDropdown);
